import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useRef, useState } from 'react';
import { JoveButton, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, Box, IconButton, InputAdornment, Typography } from '@mui/material';
import { apiJoveCheckEmailExistsInfo, apiJoveGetGoogleLoginInfo, apiJoveLogin } from 'libs/uikit/src/api/combineApi';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { validateIsEmail } from '../../../../utils/formatValidate';
import { prepareGoogleLoginSecurityParams } from '../../../../utils/googleLogin';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { GoogleIcon } from '../../../Icons/googleIcon';
import { PortalLoginSourceEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var EmailLoginForm = function EmailLoginForm(props) {
  var autoLoginOnce = props.autoLoginOnce,
      onSuccess = props.onSuccess,
      onForgotPassword = props.onForgotPassword,
      onSignUp = props.onSignUp,
      onBack = props.onBack;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      handleSubmit = _useFormContext.handleSubmit,
      setValue = _useFormContext.setValue,
      watch = _useFormContext.watch;

  var _useState = useState(!!getValues('email')),
      passwordRevealed = _useState[0],
      setPasswordRevealed = _useState[1];

  var _useState2 = useState(false),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var _useState3 = useState(false),
      googleLoading = _useState3[0],
      setGoogleLoading = _useState3[1];

  var _useState4 = useState(false),
      passwordVisible = _useState4[0],
      setPasswordVisible = _useState4[1];

  var _useState5 = useState(false),
      brokerInviteDenied = _useState5[0],
      setBrokerInviteDenied = _useState5[1];

  var _useState6 = useState(''),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var autoLoginTriggeredRef = useRef(false);
  var formRef = useRef(null);
  /**
   * request
   */

  var requestEmailContinue = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getValues, email, loginSource, slug, params, _yield$apiJoveCheckEm, _yield$apiJoveCheckEm2, res, _ref2, isBrokerMember, isRegistered;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getValues = getValues(), email = _getValues.email, loginSource = _getValues.loginSource, slug = _getValues.slug;
              params = {
                email: email
              };

              if (loginSource === PortalLoginSourceEnum.Broker && slug) {
                params.brokerSlug = slug;
              }

              setSubmitting(true);
              _context.next = 6;
              return apiJoveCheckEmailExistsInfo(params);

            case 6:
              _yield$apiJoveCheckEm = _context.sent;
              _yield$apiJoveCheckEm2 = _slicedToArray(_yield$apiJoveCheckEm, 1);
              res = _yield$apiJoveCheckEm2[0];
              setSubmitting(false);

              if (!((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE)) {
                _context.next = 25;
                break;
              }

              _ref2 = res.data || {}, isBrokerMember = _ref2.isBrokerMember, isRegistered = _ref2.isRegistered;

              if (!(loginSource === PortalLoginSourceEnum.Broker)) {
                _context.next = 21;
                break;
              }

              if (!(!isBrokerMember && !isRegistered)) {
                _context.next = 16;
                break;
              }

              setBrokerInviteDenied(true);
              return _context.abrupt("return");

            case 16:
              if (!(isBrokerMember && !isRegistered)) {
                _context.next = 19;
                break;
              }

              onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp(true);
              return _context.abrupt("return");

            case 19:
              _context.next = 24;
              break;

            case 21:
              if (isRegistered) {
                _context.next = 24;
                break;
              }

              onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp(true);
              return _context.abrupt("return");

            case 24:
              setPasswordRevealed(true);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestEmailContinue() {
      return _ref.apply(this, arguments);
    };
  }();

  var requestPasswordLogin = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _getValues2, email, password, params, _yield$apiJoveLogin, _yield$apiJoveLogin2, res, err;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getValues2 = getValues(), email = _getValues2.email, password = _getValues2.password;
              params = {
                username: email,
                password: password
              };
              setSubmitting(true);
              _context2.next = 5;
              return apiJoveLogin(params);

            case 5:
              _yield$apiJoveLogin = _context2.sent;
              _yield$apiJoveLogin2 = _slicedToArray(_yield$apiJoveLogin, 2);
              res = _yield$apiJoveLogin2[0];
              err = _yield$apiJoveLogin2[1];
              setSubmitting(false);

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res.data);
              } else {
                setErrorMessage((err === null || err === void 0 ? void 0 : err.message) || $t('text:login.login_failed'));
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestPasswordLogin() {
      return _ref3.apply(this, arguments);
    };
  }();

  var requestGoogleLogin = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _yield$prepareGoogleL, state, nonce, codeChallenge, _yield$apiJoveGetGoog, _yield$apiJoveGetGoog2, res;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setGoogleLoading(true);
              _context3.next = 3;
              return prepareGoogleLoginSecurityParams();

            case 3:
              _yield$prepareGoogleL = _context3.sent;
              state = _yield$prepareGoogleL.state;
              nonce = _yield$prepareGoogleL.nonce;
              codeChallenge = _yield$prepareGoogleL.codeChallenge;
              _context3.next = 9;
              return apiJoveGetGoogleLoginInfo({
                redirectUri: "".concat(window.location.origin, "/callback"),
                state: state,
                nonce: nonce,
                codeChallenge: codeChallenge
              });

            case 9:
              _yield$apiJoveGetGoog = _context3.sent;
              _yield$apiJoveGetGoog2 = _slicedToArray(_yield$apiJoveGetGoog, 1);
              res = _yield$apiJoveGetGoog2[0];
              setGoogleLoading(false);

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                window.location.href = res.data.authorizationUrl;
              }

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function requestGoogleLogin() {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * watch
   */


  var emailWatch = watch('email');
  var passwordWatch = watch('password');
  var loginSource = useWatch({
    control: control,
    name: 'loginSource'
  });
  var brandInfo = useWatch({
    control: control,
    name: 'brandInfo'
  });
  /**
   * effects
   */

  useEffect(function () {
    setBrokerInviteDenied(false);
    setErrorMessage('');
  }, [emailWatch, passwordWatch]);
  useEffect(function () {
    if (!autoLoginOnce || autoLoginTriggeredRef.current) return;

    var _getValues3 = getValues(),
        email = _getValues3.email,
        password = _getValues3.password;

    if (!email || !password) return;
    autoLoginTriggeredRef.current = true;
    requestPasswordLogin();
  }, [autoLoginOnce]); // Page-load autofill fills the DOM without firing input events, so poll the DOM briefly and sync any autofilled credentials into the form

  useEffect(function () {
    var checkCount = 0;
    var autofillCheckTimer = setInterval(function () {
      var _formRef$current, _formRef$current2;

      checkCount += 1;
      var emailInput = (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.querySelector('input[name="email"]');
      var passwordInput = (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.querySelector('input[name="password"]');

      if (emailInput !== null && emailInput !== void 0 && emailInput.value && passwordInput !== null && passwordInput !== void 0 && passwordInput.value) {
        clearInterval(autofillCheckTimer);

        if (!getValues('password')) {
          setValue('email', emailInput.value, {
            shouldDirty: true
          });
          setValue('password', passwordInput.value, {
            shouldDirty: true
          });
        }
      } else if (checkCount >= 10) {
        clearInterval(autofillCheckTimer);
      }
    }, 300);
    return function () {
      return clearInterval(autofillCheckTimer);
    };
  }, []); // The browser autofilled both the email and the password (saved credentials) — validate the email, then reveal the prefilled password step

  useEffect(function () {
    if (passwordRevealed) return;
    if (!passwordWatch || !validateIsEmail(getValues('email'))) return;
    requestEmailContinue();
  }, [passwordWatch, passwordRevealed]); // The password field stays mounted for autofill, so focus it imperatively once it is revealed (autoFocus would not re-fire)

  useEffect(function () {
    if (passwordRevealed) {
      var _formRef$current3, _formRef$current3$que;

      (_formRef$current3 = formRef.current) === null || _formRef$current3 === void 0 ? void 0 : (_formRef$current3$que = _formRef$current3.querySelector('input[name="password"]')) === null || _formRef$current3$que === void 0 ? void 0 : _formRef$current3$que.focus();
    }
  }, [passwordRevealed]);
  /**
   * methods
   */

  var continueWithEmailAction = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              handleSubmit(requestEmailContinue)();

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function continueWithEmailAction() {
      return _ref5.apply(this, arguments);
    };
  }();

  var loginAction = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              handleSubmit(requestPasswordLogin)();

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function loginAction() {
      return _ref6.apply(this, arguments);
    };
  }();

  var forgotPasswordAction = function forgotPasswordAction() {
    onForgotPassword === null || onForgotPassword === void 0 ? void 0 : onForgotPassword();
  };

  var signUpAction = function signUpAction() {
    onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp();
  };

  var googleLoginAction = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!googleLoading) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              requestGoogleLogin();

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function googleLoginAction() {
      return _ref7.apply(this, arguments);
    };
  }();

  var backAction = function backAction() {
    onBack === null || onBack === void 0 ? void 0 : onBack();
  };

  var togglePasswordVisibilityAction = function togglePasswordVisibilityAction() {
    setPasswordVisible(function (visible) {
      return !visible;
    });
  };

  var continueAction = function continueAction() {
    if (passwordRevealed) {
      loginAction();
      return;
    }

    continueWithEmailAction();
  };

  var submitFormAction = function submitFormAction(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    continueAction();
  }; // email-only step only checks the account ('Continue'); once the password is revealed the button performs the actual login ('Log in')


  var idleButtonText = passwordRevealed ? $t('text:login.log_in') : $t('text:login.continue');
  var loadingButtonText = passwordRevealed ? $t('text:login.logging_in') : $t('text:login.checking');
  var continueButtonText = submitting ? loadingButtonText : idleButtonText;

  var validateEmail = function validateEmail(value) {
    return validateIsEmail(value) ? true : $t('text:login.valid_email');
  };

  var passwordEndAdornment = /*#__PURE__*/_jsx(InputAdornment, {
    position: "end",
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      edge: "end",
      "aria-label": "toggle password visibility",
      onClick: togglePasswordVisibilityAction,
      children: passwordVisible ? /*#__PURE__*/_jsx(VisibilityOff, {
        fontSize: "small"
      }) : /*#__PURE__*/_jsx(Visibility, {
        fontSize: "small"
      })
    })
  });

  return /*#__PURE__*/_jsxs(Box, {
    component: "form",
    noValidate: true,
    className: "flex w-full flex-col space-y-6",
    onSubmit: submitFormAction,
    ref: formRef,
    children: [loginSource !== PortalLoginSourceEnum.Broker && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-2 text-center",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: $t('text:login.welcome')
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-base text-gray-500",
        children: $t('text:login.new_member_hint')
      })]
    }), loginSource === PortalLoginSourceEnum.Broker && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-2",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: $t('text:login.log_into_your_portal')
      }), !!(brandInfo !== null && brandInfo !== void 0 && brandInfo.name) && /*#__PURE__*/_jsx(Typography, {
        className: "text-base text-gray-500",
        children: brandInfo.name
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col",
      children: [/*#__PURE__*/_jsx(JoveTextFieldControlled, {
        name: "email",
        control: control,
        rules: {
          validate: validateEmail
        },
        autoFocus: !passwordRevealed,
        autoComplete: "username",
        type: "email",
        label: $t('text:login.email_label'),
        placeholder: $t('text:login.email_placeholder'),
        containerClassName: "mb-3"
      }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
        name: "password",
        control: control,
        rules: {
          required: passwordRevealed ? $t('text:login.enter_password') : false
        },
        autoComplete: "current-password",
        type: passwordVisible ? 'text' : 'password',
        label: $t('text:login.password_label'),
        placeholder: $t('text:login.password_placeholder'),
        endAdornment: passwordRevealed ? passwordEndAdornment : undefined,
        containerClassName: passwordRevealed ? 'mb-1' : 'pointer-events-none h-0 overflow-hidden opacity-0',
        inputProps: {
          tabIndex: passwordRevealed ? 0 : -1,
          'aria-hidden': !passwordRevealed
        }
      }), brokerInviteDenied && /*#__PURE__*/_jsx(Alert, {
        severity: "error",
        className: "mb-1",
        children: $t('text:login.broker_invite_denied', {
          brand: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.name
        })
      }), errorMessage && /*#__PURE__*/_jsx(Alert, {
        severity: "error",
        className: "mb-1",
        children: errorMessage
      }), /*#__PURE__*/_jsx(Typography, {
        component: "button",
        type: "button",
        className: "cursor-pointer self-start text-sm font-semibold text-[#CD0D47] hover:underline",
        onClick: forgotPasswordAction,
        children: $t('text:login.forget_password')
      })]
    }), /*#__PURE__*/_jsx(JoveButton, {
      type: "submit",
      variant: "contained",
      color: "primary",
      size: "large",
      loading: submitting,
      startIcon: submitting ? /*#__PURE__*/_jsx("span", {}) : undefined,
      className: "w-full",
      children: continueButtonText
    }), /*#__PURE__*/_jsxs(Typography, {
      className: "text-center text-sm text-gray-500",
      children: [$t('text:login.dont_have_account'), ' ', /*#__PURE__*/_jsx(Typography, {
        component: "span",
        className: "cursor-pointer font-semibold text-[#CD0D47] hover:underline",
        onClick: signUpAction,
        children: $t('text:login.sign_up')
      })]
    }), loginSource !== PortalLoginSourceEnum.Broker && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center space-x-4",
        children: [/*#__PURE__*/_jsx(Box, {
          className: "h-px flex-1 bg-gray-200"
        }), /*#__PURE__*/_jsx(Typography, {
          className: "text-xs font-medium tracking-wide text-gray-400",
          children: $t('text:login.or')
        }), /*#__PURE__*/_jsx(Box, {
          className: "h-px flex-1 bg-gray-200"
        })]
      }), /*#__PURE__*/_jsx(JoveButton, {
        type: "button",
        variant: "outlined",
        color: "primary",
        size: "large",
        startIcon: GoogleIcon(),
        loading: googleLoading,
        disabled: submitting,
        className: "w-full",
        onClick: googleLoginAction,
        children: $t('text:login.continue_with_google')
      })]
    }), !!onBack && /*#__PURE__*/_jsx(Typography, {
      className: "cursor-pointer self-start text-xs font-semibold text-[#CD0D47] hover:underline",
      onClick: backAction,
      children: $t('text:back')
    })]
  });
};

export default EmailLoginForm;